import { useReadChannelPlayerBaseInfo } from './use-read-channel-player-base-info';

export const useIsForcedSubtitles = (contentId: string) => {
    const baseInfo = useReadChannelPlayerBaseInfo(contentId);

    return baseInfo?.onlineStreams?.playerRestrictionConfig?.subtitlesButtonEnable === false;
};
